import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseIconButton, LinkIconButton } from './BaseIconButton';

const tertiaryIconButtonStyle = {
    color: colorSystem.neutral[7],
    '&:hover': {
        background: 'none',
        color: colorSystem.primary[6],
    },
    '&:active': {
        background: 'none',
        color: colorSystem.primary[7],
    },
    '&:disabled': {
        color: colorSystem.neutral[5],
    },
};

const TertiaryIconButtonHost = styled(BaseIconButton)(tertiaryIconButtonStyle);
const TertiaryIconButtonLinkHost = styled(LinkIconButton)(tertiaryIconButtonStyle);

export const TertiaryIconButton = linkable(TertiaryIconButtonHost, { linkHost: TertiaryIconButtonLinkHost });
